// Workspace type scale — OWNS the app's root font-size steps (brand's
// typography only fills gaps via deepDefaults, so values here win without
// touching brand's marketing-page scale).
//
// Scratch turns every `@<media>` step into a ROOT font-size template
// (`base / 16` em on html — smbls/packages/scratch/src/system/typography.js
// runThroughMedia), and the whole token system is EM-based, so each step
// scales text AND spacing together: smaller base = proportionally denser
// UI, not just smaller words. That is the lever for Nika 2026-08-18
// "reduce workspace font size for small screens so it fits more content".
//
// Steps (brand ships 17 → 16 @screenS → 15 @tabletS and stops there; the
// workspace is a dense tool on a tablet, so it goes one step further there):
//   base      17    (desktop, unchanged)
//   @screenS  16    (≤1440, unchanged)
//   @tabletS  14    (≤1024 — was 15; −6.7%)
//   @mobileL  16    (≤768 — a PHONE reads at the laptop root, see below)
//   @mobileM  16    (≤560 — same)
//
// The phone steps used to shrink further (13.5 / 13, 2026-08-18). Measured
// on dev 2026-09-10 at 390px: a 13px root put body copy at 13px, captions at
// 11px, the shortcut labels at 12px and the greeting at 16px — Nika: "fonts
// too small". A phone is read at arm's length with the thumb on the glass,
// so it takes the LAPTOP root (16 — the web's default body size, iOS body is
// 17) with the tightest ratio (1.1): headings stay close to the body instead
// of exploding on a narrow screen, and every em-based spacing token grows
// with it (A 13 → 16, B 21 → 26), which is what gives the dashboard lane its
// room (pages/main.js phone lane). Tablets keep their dense step.
// Each media step must restate `ratio` — runThroughMedia merges from the
// TOP-LEVEL factory (ratio 1.2), not from the previous step, so an
// unstated ratio would silently jump back to 1.2.
//
// Guard rails already in place elsewhere: inputs/textareas are floored at
// 16px on touch widths (app.js iOS zoom-on-focus guard), and device-
// physical chrome is px-pinned by design (shared sizes.js §3/§6), so
// neither zooms nor shrinks with these steps.
export default {
  base: 17,
  ratio: 1.2,
  subSequence: true,
  '@screenS': {
    base: 16,
    ratio: 1.15
  },
  '@tabletS': {
    base: 14,
    ratio: 1.1
  },
  '@mobileL': {
    base: 16,
    ratio: 1.1
  },
  '@mobileM': {
    base: 16,
    ratio: 1.1
  }
}
